import React from 'react';
import PropTypes from 'prop-types';
import Jumbo from 'components/Components/Sections/Jumbo';
import HotelPageSubMenu from 'components/Components/Pages/HotelPage/HotelPageSubMenu';
import Gallery from 'components/Components/Sections/Gallery';
import RoomsSection from 'components/Components/Pages/HotelPage/RoomsSection';
import CallUs from 'components/Components/Sections/CallUs';
import RoomOverview from 'components/Components/Pages/HotelPage/RoomOverview';

function HotelRoomSection({
    destinationSlug, parentDestinationSlug, regionSlug, headerHeight, hotel, hotelRoom, onClickQuote,
})
{
    return (
        <>
            {/* Jumbo Banner Section */}
            <Jumbo
                image={hotel.hotelPictures.find(e => e.type === 'Header') ? hotel.hotelPictures.find(e => e.type === 'Header').path : ''}
                title={hotel.name}
                subtitle={hotel.destination ? hotel.destination.name : ''}
                vanish
            />

            {/* Sub Menu Section */}
            <HotelPageSubMenu
                hasPictures={hotelRoom.hotelRoomPictures.length > 0}
                headerHeight={headerHeight}
                hotel={hotel}
                hideOffers
                hideMap
            />

            {/* Room Overview Section */}
            <RoomOverview hotelRoom={hotelRoom} />

            {/* Gallery Section */}
            {hotelRoom.hotelRoomPictures.length > 0 && (
                <Gallery
                    images={hotelRoom.hotelRoomPictures}
                    element={hotelRoom.name}
                    title="Room Gallery"
                />
            )}

            {/* Rooms Section */}
            {hotel.hotelRooms.length > 0 && (
                <RoomsSection
                    parentDestinationSlug={parentDestinationSlug}
                    destinationSlug={destinationSlug}
                    regionSlug={regionSlug}
                    hotel={hotel}
                    onClickQuote={onClickQuote}
                    title="More Rooms"
                />
            )}

            {/* Call Us Section */}
            <CallUs
                bgColor="tw-bg-gray-300"
                showEmailButton={false}
            />
        </>
    );
}

HotelRoomSection.propTypes = {
    destinationSlug: PropTypes.string.isRequired,
    parentDestinationSlug: PropTypes.string,
    regionSlug: PropTypes.string.isRequired,
    headerHeight: PropTypes.number,
    hotel: PropTypes.object.isRequired,
    hotelRoom: PropTypes.object.isRequired,
    onClickQuote: PropTypes.func.isRequired,
};

export default HotelRoomSection;
